import { Navigate, Outlet } from 'react-router';
import { ROUTES } from '@/shared/config/routes';
import { useViewer } from '../hooks/use-viewer';
import { hasConnectedAgent } from '../model/plan-label';

type WorkspaceGuardProps = { expects: 'workspace' | 'no-workspace' };

/** New accounts name their workspace first; people with a workspace never see that step again. */
export function WorkspaceGuard({ expects }: WorkspaceGuardProps) {
  const { workspace } = useViewer();
  if (expects === 'workspace' && !workspace) return <Navigate to={ROUTES.WELCOME} replace />;
  if (expects === 'no-workspace' && workspace) {
    const { claudeCode, codex } = workspace.connections;
    const isConnected = hasConnectedAgent([claudeCode.status, codex.status]);
    return <Navigate to={isConnected ? ROUTES.OVERVIEW : ROUTES.GET_STARTED} replace />;
  }
  return <Outlet />;
}
